import React, { useState, useEffect } from 'react';

import { FreecodePlayer } from 'components/FreecodePlayer/freecodePlayer';
import { SearchSelect } from 'components/searchSelect/searchSelect';
import { RankListPlayerContainer } from './styles';

export default function RankListPlayBack({ matchData, testImplementation }) {
  const [matchOptions, setMatchOptions] = useState([]);
  const [matchIndex, setMatchIndex] = useState(0);

  useEffect(() => {
    if (matchData?.length) {
      let mappedOptionArray = matchData.map((match, index) => {
        let label = `Match ${index + 1}`;
        let participants = match?.participants?.map((value) => value?.name)?.join(', ') ?? '';
        if (participants) {
          label = `${label} - ${participants}`;
        }
        return { label: label, value: index };
      });
      setMatchOptions(mappedOptionArray);
    }
  }, [matchData]);

  const selectMatchup = (index) => {
    if (matchIndex !== index) {
      setMatchIndex(index);
    }
  };

  const getRankListPlayer = () => (
    <RankListPlayerContainer>
      <SearchSelect
        options={matchOptions}
        onChange={(event) => selectMatchup(event.value)}
        value={matchIndex}
        placeholder={matchOptions?.[matchIndex]?.label ?? 'Select Match'}
        className="VirtualizedSelectCustom"
      />
      <FreecodePlayer testImplementation={testImplementation} levels={matchData[matchIndex].levels} />
    </RankListPlayerContainer>
  );

  return matchData && testImplementation ? getRankListPlayer() : <div>No data found</div>;
}
